
import React from "react";
import FormField from "@/components/forms/FormField";
import MediaUpload from "@/components/forms/MediaUpload";

interface TagsAndMediaSectionProps {
  tags: string;
  mediaFiles: File[];
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleMediaChange: (files: FileList) => void;
  formErrors: Record<string, string>;
}

const TagsAndMediaSection: React.FC<TagsAndMediaSectionProps> = ({
  tags,
  mediaFiles,
  handleChange,
  handleMediaChange,
  formErrors,
}) => {
  return (
    <>
      <MediaUpload 
        onChange={handleMediaChange}
        error={formErrors.mediaFiles}
        selectedFiles={mediaFiles}
      />

      <FormField
        id="tags"
        label="Tags (comma separated, e.g., organic, zero-waste)"
        required
        value={tags}
        onChange={handleChange}
        error={formErrors.tags}
      />
    </>
  );
};

export default TagsAndMediaSection;
